import { Routes, Route } from "react-router-dom";
import ReportsAccessWrapper from "../report/reportAccessWrapper";
import ReportList from "./reportList";
import { useContextForPermission } from "../../hooks/usePermission";

/**
 * Reports component renders routes for accessing report details and displaying report list.
 *
 * @returns {JSX.Element} A set of routes for report access and report list display.
 */
export default function Reports() {
  const { canView } = useContextForPermission("REPO");

  return (
    <Routes>
      <Route path=":reportId/*" element={<ReportsAccessWrapper />} />
      <Route path="/" element={<ReportList hasPermission={canView} />} />
    </Routes>
  );
}
